<template>
  <section class="component-list-learning">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 col-auto m-auto" v-for="(item,index) in items" :key="index">
        <div class="panel-card p-0 pb-2 box-learning">
          <div class="box-video box-shadow ">
            <i class="flaticon-play-1 icon-play"></i>
            <img class="card-img-top" :src="appUrl.media +'/'+ item.Img" />
          </div>
          <article class="text-right p-2">
            <h2 class="font-16">
              {{item.course_title}}
            </h2>
            <i class="font-14">
              {{item.fullname}} {{item.subcategory}}
            </i>
          </article>
          <div class="d-flex justify-content-center align-items-center">
            <div class="form-action form-action-center">
              <div class="col-12 px-1 text-center">
                <!-- <router-link v-if="isGet" :to="'/list-content/'+item.id" class=" d-inline-block bttn-fill bttn bttn-primary btn-block" v-ripple  :title="$t('button.courseStart')"> -->
                <router-link v-if="isGet" :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ (item.course_id || item.id) + '/' + item.course_title_en+'/list-content'" class=" d-inline-block bttn-fill bttn bttn-primary btn-block" v-ripple :title="$t('button.courseStart')">
                  جزییات دوره
                </router-link>
                <router-link v-if="isEnroll" :to="'/courses/'+item.en_category +'/'+ item.en_subcategory +'/'+ (item.course_id || item.id) + '/' + item.course_title_en+'/list-content'" class=" d-inline-block bttn-fill bttn bttn-primary btn-block" v-ripple :title="$t('button.courseStart')">
                  <i class=" mdi mdi-clock-start"></i>
                  مشاهده دوره
                </router-link>
                <button @click="getForEdit(item,index)" v-if="isEdit && item.editable" class="font-14 py-2 d-inline-block bttn-fill bttn bttn-primary btn-block" v-ripple :title="' ویرایش دوره'">
                  <!-- <i class=" mdi mdi-table-edit"></i> -->
                  ویرایش دوره
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'component-list-learning',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isEnroll: {
      type: Boolean,
      default: false,
      required: false
    },
    isGet: {
      type: Boolean,
      default: false,
      required: false
    },
    isEdit: {
      type: Boolean,
      default: false,
      required: false

    }
  },
  methods: {
    getForEdit (item, index) {
      sessionStorage.setItem('course_id', item.id)
      this.$router.push('new-course')
    }
  }
}
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
.component-list-learning {
  .box-clear;
  .box-learning {
    .box-video {
      position: relative;
      // min-height: 130px;
      cursor: pointer;
      min-height: 190px;
      // height: 195px;
      overflow: hidden;
      &:before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 2;

        background: rgba(0, 0, 0, 0.3);
      }
      .icon-play {
        color: #fff;
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        z-index: 4;

        &:before {
          transition: transform 200ms ease-in-out, box-shadow 400ms ease-in;
          font-size: 26px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: fade(@green, 60);
          text-align: center;
          line-height: 50px;
          display: block;
          box-shadow: 0px 0px 5px 0px rgba(1, 1, 1, 0.15);
        }
      }
      &:hover {
        .icon-play {
          &:before {
            transform: scale(1.5);
            box-shadow: 0px 0px 10px 0px rgba(1, 1, 1, 0.4);
          }
        }
      }
    }
    .form-action {
      a {
        font-size: 14px;
      }
    }
    article {
      min-height: 90px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list-learning.vue